import { List } from 'components/ui';
import ListItem from 'components/space/order/index/list_item';
import ListHeader from 'components/space/order/index/list_header';

const Index = ({ orders }) => {
  return (
    <List>
      {orders.length > 0 && <ListHeader />}
      {orders.map((order) => (
        <ListItem key={order.id} order={order} />
      ))}
    </List>
  );
};

export default Index;
